import { picklist, type InferInput } from "valibot";

export type LanguageCode = InferInput<typeof LanguageCode>;
export const LanguageCode = picklist([
  "cs",
  "da",
  "de",
  "el",
  "en",
  "es",
  "fi",
  "fr",
  "hr",
  "hu",
  "it",
  "ja",
  "ko",
  "ms",
  "nl",
  "no",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "sv",
  "th",
  "zh",
]);
